import Api from "@/services/api";
import {
    VscFile,
    FilesFilterDtoIn,
    FileInfo,
    FilesDuplicatesDtoIn,
    FileNameUpdateDtoIn,
    FilesFilterDtoOut,
    FileUsageResult, UnsplashImageDtoIn
} from "@/services/files/types";
import { FolderEntites } from "@/services/folders/types";

export async function deleteFile(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.delete(`/files/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getFilteredFiles(model: FilesFilterDtoIn): Promise<FilesFilterDtoOut> {
    return new Promise((resolve, reject) => {
        Api.post("/files/filter", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function GetFileInfo(id: string): Promise<FileInfo> {
    return new Promise((resolve, reject) => {
        Api.get(`/files/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFolder(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.get(`/files/${id}/folder`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<FileUsageResult> {
    return new Promise((resolve, reject) => {
        Api.get(`/files/checkdelete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function postFile(data: FormData, config: any): Promise<VscFile> {
    return new Promise((resolve, reject) => {
        Api.postFormData("/files", data, config).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUnsplashAccessKey(): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.get(`/files/UnsplashAccessKey`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function downloadUnsplashImage(model: UnsplashImageDtoIn): Promise<VscFile> {
    return new Promise((resolve, reject) => {
        Api.post("/files/DownloadUnsplashImage", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDuplicates(model: FilesDuplicatesDtoIn): Promise<string[]> {
    return new Promise((resolve, reject) => {
        Api.post("/files/checkDuplicates", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateName(model: FileNameUpdateDtoIn): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post("/files/UpdateName", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFileFolderEntity(id: string): Promise<FolderEntites> {
    return new Promise((resolve, reject) => {
        Api.get(`/files/GetFileFolderEntity/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
